<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperActionRow from './HelperActionRow.vue'

defineOptions({
  name: 'HelpersSalesPage',
})
</script>

<template>
  <HelpersGrid>
    <CardAdmin
      title="Kanban"
      fullwidth
    >
      <HelperActionRow
        label="DTS: Schedule Notifications"
        route-name="admin.helpers.kanban.dts-notification"
      />
    </CardAdmin>
    <CardAdmin
      title="SQA"
      fullwidth
    >
      <HelperActionRow
        label="SQA Autoassign"
        route-name="admin.helpers.sqa.agent-assign"
      />
      <HelperActionRow
        label="SQA Set Call Status"
        route-name="admin.helpers.sqa.sale-status-call-now"
      />
      <HelperActionRow
        label="SQA Clear"
        route-name="admin.helpers.sqa.clear-agent-slots"
      />
    </CardAdmin>
  </HelpersGrid>
</template>
